module.exports = __webpack_public_path__ + "img/home.91d8a471.jpg";